<template>
  <div style="position: fixed; right: 0; bottom: 0" v-show="false">
    <v-menu top>
      <template v-slot:activator="{ on }">
        <v-icon large v-on="on">language</v-icon>
      </template>

      <v-list>
        <v-list-item
          v-for="(language, key) in $language.available"
          :value="key"
          :key="key"
          @click="setLocale(key)"
          autocomplete
          :class="key === $language.current ? 'highlighted' : ''"
        >
          <v-list-item-title>{{ language }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'AppLanguageMenu',
}
</script>

<style lang="scss" scoped></style>
